<template>
  <div class="progress-bar">
    <div class="progress-bar__progress">
      <div class="columns progress-bar__header">
        <div>
          <h5 v-html="model.TitleProgressBar" />
          <p class="show-for-large" v-html="model.LabelProgressBar" />
        </div>
      </div>
      <div
        id="additional-information"
        :class="['columns', { done: currentTemplate === 'checkout-summary' }]"
      >
        <div class="bg" />
        <div class="progress-bar__content">
          <div class="columns shrink number" v-html="model.IndexProgressStep1" />
          <div class="columns shrink check">
            <i class="icon icon-check" />
          </div>
          <div class="columns show-for-large" v-html="model.LabelProgressStep1" />
        </div>
      </div>
      <div id="summary" :class="['columns', { active: currentTemplate === 'checkout-summary' }]">
        <div class="bg" />
        <div class="progress-bar__content">
          <div class="columns shrink number" v-html="model.IndexProgressStep1" />
          <div class="columns shrink check">
            <i class="icon icon-check" />
          </div>
          <div class="columns show-for-large" v-html="model.LabelProgressStep2" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import CheckoutContentModel from '../interfaces/CheckoutContentModel';

export default defineComponent({
  name: 'CheckoutProgressBarView',
  props: {
    model: {
      type: Object as PropType<CheckoutContentModel>,
      default() {
        return null;
      }
    },
    currentTemplate: {
      type: String,
      default() {
        return '';
      }
    }
  }
});
</script>
